// TODO: rename FamilyAndDwellingCondition
import { HorizontalBar, Bar, Line } from "react-chartjs-2";
import createChartComponentsForDiagramConfigs from "./CaptionTableChartComponent.js";
import { shortenLabels, addCommasToLabels } from "Config/chartjs.global";
import Tables from "Components/Tables/Households";
import GenericTable from "Components/Tables/GenericTable";
import Captions from "Captions";
import round from "Utils/round";
import config from "Config";

const DiagramData = {
  "Family Composition": {
    ChartComponent: HorizontalBar,
    TableComponent: Tables["Family Composition"] || GenericTable,
    queries: ["CATEGORY_FAMILY_COMPOSITION"],
    captionDataDerive: (_data) =>
      ({}.tap((data) => {
        let maxIndex = _data.datasets[0].data.reduce(
          (maxI, current, index) =>
            _data.datasets[0].data[maxI] > _data.datasets[0].data[index]
              ? maxI
              : index,
          NaN
        );

        data.max_name =
          typeof _data.labels[maxIndex] === "object"
            ? _data.labels[maxIndex].join(" ")
            : _data.labels[maxIndex];
        data.number = _data.datasets[0].data[maxIndex];
        data.total_perc = round(1)(
          data.number /
            ((_data.total_population) / 100)
        );

        data.max_count_state = _data.rows_state.reduce(
          (sum, { fmcf_main: name, number }) =>
            name == data.max_name ? sum + number : sum,
          0
        );

        data.total_perc_state = round(1)(
          data.max_count_state / (_data.total_population_state / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      {
        rows: [{ number: total_population }],
      },
      { rows: rows_state },
      {
        rows: [{ number: total_population_state }],
      },
      {
        rows: [{ number: total_population_na }],
      },
    ]) => ({
      labels: [...new Set(rows.map(({ fmcf_main }) => fmcf_main))],
      total_population,
      total_population_state,
      rows_state,
      total_population_na,
      datasets: [
        {
          label: "Family Composition",
          backgroundColor: config.primary_chart_color,
          data: rows.map((r) => r["number"]),
        },
      ],
      table: {
        rows,
        fields,
        name: "Family Composition",
      },
    }),
    chartOptions: {
      tooltips: {
        callbacks: {
          label: addCommasToLabels,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              callback: (label, index, labels) => {
                return shortenLabels(label);
              },
            },
          },
        ],
      },
    },
    height: 400,
    footnote: [
      "Source: ABS {{year}} Census - Counting Persons, Place of Enumeration",
    ],
  },
  "Children in Family": {
    ChartComponent: HorizontalBar,
    TableComponent: Tables["Children in Family"] || GenericTable,
    queries: ["CATEGORY_CHILDREN_IN_FAMILY"],
    captionDataDerive: (_data) =>
      ({}.tap((data) => {
        let maxIndex = _data.datasets[0].data.reduce(
          (maxI, current, index) =>
            _data.datasets[0].data[maxI] > _data.datasets[0].data[index]
              ? maxI
              : index,
          NaN
        );
        data.max_name =
          typeof _data.labels[maxIndex] === "object"
            ? _data.labels[maxIndex].join(" ")
            : _data.labels[maxIndex];
        data.max_count = _data.datasets[0].data[maxIndex];
        data.total_perc = round(1)(
          data.max_count /
            (_data.datasets[0].data.reduce((sum, amount) => sum + amount, 0) /
              100)
        );

        data.max_count_state = _data.rows_state.reduce(
          (sum, { cdcf_main: name, number }) =>
            name == data.max_name ? sum + number : sum,
          0
        );

        data.total_perc_state = round(1)(
          data.max_count_state /
            (_data.rows_state.reduce((sum, { number }) => sum + number, 0) /
              100)
        );
      })),
    dataPipeline: () => ([{ rows, fields }, _, { rows: rows_state }]) => ({
      labels: [...new Set(rows.map(({ cdcf_main }) => cdcf_main))],
      rows_state,
      datasets: [
        {
          label: "Children in Family",
          backgroundColor: config.primary_chart_color,
          data: rows.map((r) => r["number"]),
        },
      ],
      table: {
        rows,
        fields,
        name: "Children in Family",
      },
    }),
    chartOptions: {
      tooltips: {
        callbacks: {
          label: addCommasToLabels,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              callback: (label, index, labels) => label.split(":"),
            },
          },
        ],
      },
    },
    height: 400,
    footnote: [
      "Source: ABS {{year}} Census - Counting Persons, Place of Enumeration",
    ],
  },
  "Residents in Dwelling": {
    ChartComponent: Bar,
    TableComponent: Tables["Residents in Dwelling"] || GenericTable,
    queries: ["CATEGORY_RESIDENTS_IN_DWELLING"],
    captionDataDerive: (_data) =>
      ({}.tap((data) => {
        let maxIndex = _data.datasets[0].data.reduce(
          (maxI, current, index) =>
            _data.datasets[0].data[maxI] > _data.datasets[0].data[index]
              ? maxI
              : index,
          NaN
        );
        data.max_name =
          typeof _data.labels[maxIndex] === "object"
            ? _data.labels[maxIndex].join(" ")
            : _data.labels[maxIndex];
        data.max_count = _data.datasets[0].data[maxIndex];
        data.total_perc = round(1)(
          data.max_count /
            ((_data.total_population) / 100)
        );

        data.max_count_state = _data.rows_state.reduce(
          (sum, { nprd_number_of_persons_usually_resident_in_dwe: name, number }) =>
            name == data.max_name ? sum + number : sum,
          0
        );

        data.total_perc_state = round(1)(
          data.max_count_state / (_data.total_population_state / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      {
        rows: [{ number: total_population }],
      },
      { rows: rows_state },
      {
        rows: [{ number: total_population_state }],
      },
    ]) =>
      [
        "One person",
        "Two persons",
        "Three persons",
        "Four persons",
        "Five persons",
        "Six or more persons",
      ]
        .reduce(
          ({ labels, data }, label) => ({
            labels: labels.concat(label),
            data: data.concat(
              [
                rows.find(
                  ({ nprd_number_of_persons_usually_resident_in_dwe }) =>
                    nprd_number_of_persons_usually_resident_in_dwe == label
                ),
              ].chain(([{ number }]) => (number ? number : 0))
            ),
          }),
          {
            data: [],
            labels: [],
          }
        )
        .chain(({ labels, data }) => ({
          labels,
          datasets: [
            {
              label: "Residents in Dwelling",
              backgroundColor: config.primary_chart_color,
              data,
            },
          ],
          total_population,
          total_population_state,
          rows_state,
          table: {
            rows,
            fields,
            name: "Residents in Dwelling",
          },
        })),
    footnote: [
      "Source: ABS {{year}} Census - Counting Persons, Place of Enumeration",
    ],
  },
  "Internet Access": {
    missingFor2021: true,
    ChartComponent: HorizontalBar,
    queries: ["CATEGORY_INTERNET_ACCESS"],
    TableComponent: Tables["Internet Access"] || GenericTable,
    // missingFor2016: true,
    captionDataDerive: (_data) =>
      ({}.tap((data) => {
        let maxIndex = _data.datasets[0].data.reduce(
          (maxIndex, b, index) =>
            _data.datasets[0].data[maxIndex] > b ? maxIndex : index,
          0
        );

        data.max_name =
          typeof _data.labels[maxIndex] === "object"
            ? _data.labels[maxIndex].join(" ")
            : _data.labels[maxIndex];
        data.max_count = _data.datasets[0].data[maxIndex];
        data.total_perc = round(1)(
          data.max_count /
            ((_data.total_population) / 100)
        );

        data.max_count_state = _data.rows_state.reduce(
          (sum, { nedd_type_of_internet_connection: name, number }) =>
            name == data.max_name ? sum + number : sum,
          0
        );

        data.total_perc_state = round(1)(
          data.max_count_state / (_data.total_population_state / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      {
        rows: [{ number: total_population }],
      },
      { rows: rows_state },
      {
        rows: [{ number: total_population_state }],
      },
      {
        rows: [{ number: total_population_na }],
      },
    ]) => ({
      labels: rows.map(({ nedd_type_of_internet_connection }) =>
        shortenLabels(nedd_type_of_internet_connection)
      ),
      total_population,
      total_population_state,
      rows_state,
      total_population_na,
      datasets: [
        {
          label: "Internet Access",
          backgroundColor: config.primary_chart_color,
          data: rows.map((r) => r["number"]),
        },
      ],
      table: {
        rows,
        fields,
        name: "Internet Access",
      },
    }),
    chartOptions: {
      tooltips: {
        callbacks: {
          label: addCommasToLabels,
        },
      },
    },
    footnote: [
      "Source: ABS {{year}} Census - Counting Persons, Place of Enumeration",
    ],
  },
  "Household Income": {
    ChartComponent: HorizontalBar,
    queries: ["CATEGORY_HOUSEHOLD_INCOME"],
    TableComponent: Tables["Household Income"] || GenericTable,
    captionDataDerive: (_data) =>
      ({}.tap((data) => {
        let maxIndex = _data.datasets[0].data.reduce(
          (maxI, current, index) =>
            _data.datasets[0].data[maxI] > _data.datasets[0].data[index]
              ? maxI
              : index,
          NaN
        );
        data.max_name =
          typeof _data.labels[maxIndex] === "object"
            ? _data.labels[maxIndex].join(" ")
            : _data.labels[maxIndex];

        data.max_count = _data.datasets[0].data[maxIndex];

        data.total_perc = round(1)(
          data.max_count /
            ((_data.total_population) / 100)
        );
        data.max_count_state = _data.rows_state.reduce(
          (sum, { hind_total_household_income_weekly: name, number }) =>
            name == data.max_name ? sum + number : sum,
          0
        );

        data.total_perc_state = round(1)(
          data.max_count_state / (_data.total_population_state / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      { rows: [{ number: total_population }],},
      { rows: rows_state },
      {
        rows: [{ number: total_population_state }],
      },
    ]) => ({
      labels: [
        ...new Set(
          rows.map(
            ({ hind_total_household_income_weekly }) =>
              hind_total_household_income_weekly
          )
        ),
      ],
      datasets: [
        {
          label: "Household Income",
          backgroundColor: config.primary_chart_color,
          data: rows.map((r) => r["number"]),
        },
      ],
      total_population,
      total_population_state,
      rows_state,
      table: {
        rows,
        fields,
        name: "Household Income",
      },
    }),
    chartOptions: {
      tooltips: {
        callbacks: {
          label: addCommasToLabels,
        },
      },
    },
    footnote: [
      "Source: ABS {{year}} Census - Counting Persons, Place of Enumeration",
    ],
  },
  "Socioeconomic disadvantage (SEIFA)": {
    // notYetReleasedFor2021: true,
    ChartComponent: Bar,
    queries: ["CATEGORY_SEIFA"],
    footnote: [
      "Decile: This variable uses the ABS's Index of Relative Socio-economic Disadvantage (IRSD) (see: http://tiny.cc/ABS-IRSD). For more information on interpreting this variable (see: http://tiny.cc/ABS-IRSD-VAR)",
      // "Decile: This variable uses the ABS's <a target='_blank' rel='noopener' href='https://www.abs.gov.au/ausstats/abs@.nsf/Lookup/by%20Subject/2033.0.55.001~2016~Main%20Features~IRSD~19'>Index of Relative Socio-economic Disadvantage (IRSD)</a>. For more information on interpreting this variable <a target='_blank' rel='noopener' href='https://www.abs.gov.au/websitedbs/censushome.nsf/home/seifahelpansuis?opendocument&navpos=260&#03'>click here</a>"
    ],
    TableComponent:
      Tables["Socioeconomic disadvantage (SEIFA)"] || GenericTable,
    // missingFor2016: true,
    captionDataDerive: (_data) =>
      ({}.tap((data) => {
        let maxIndex = _data.datasets[0].data.reduce(
          (maxI, current, index) =>
            _data.datasets[0].data[maxI] > _data.datasets[0].data[index]
              ? maxI
              : index,
          NaN
        );
        data.max_name =
          typeof _data.labels[maxIndex] === "object"
            ? _data.labels[maxIndex].join(" ")
            : _data.labels[maxIndex];
        data.max_count = _data.datasets[0].data[maxIndex];
        data.total_perc = round(1)(
          data.max_count /
            ((_data.total_population) / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      {
        rows: [{ number: total_population }],
      },
    ]) =>
      rows
        .sort((a, b) =>
          [a.irsd_deciles_at_lga_level_pop, b.irsd_deciles_at_lga_level_pop]
            .map((val) => parseInt(val.replace(/^[^\d]*(\d+)/, "$1"), 10))
            .chain(([a, b]) => a - b)
        )
        .chain((sorted_rows) => ({
          labels: sorted_rows.map(
            ({ irsd_deciles_at_lga_level_pop }) => irsd_deciles_at_lga_level_pop
          ),
          total_population,
          datasets: [
            {
              label: "Socioeconomic disadvantage (SEIFA)",
              backgroundColor: config.primary_chart_color,
              data: sorted_rows.map((r) => r["number"]),
            },
          ],
          table: {
            rows,
            fields,
            name: "Socioeconomic disadvantage (SEIFA)",
          },
        })),
  },
}.tap((diagrams) =>
  Object.keys(Captions["Households and Income"]).forEach(
    (key) => (diagrams[key].captions = Captions["Households and Income"][key])
  )
);

export default createChartComponentsForDiagramConfigs(DiagramData);



// WEBPACK FOOTER //
// ./components/Charts/Households.js